import { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setContato, setConversa, setEmpresa, setNegocio, setGrupoWhatsapp } from 'src/redux/slices/global';

import Iconify from 'src/components/Iconify';
import { Button } from 'src/@/components/ui/button';
import { BOTAO_RELEVO_PRIMARIO } from 'src/utils/buttonStyles';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from 'src/@/components/ui/dropdown-menu';
import { verifyRules } from 'src/utils/functions';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

MenuOptionsNovo.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object
};

export default function MenuOptionsNovo({
    children,
    sx,
    inicial,
    final,
    changeInicial,
    changeFinal,
    onSelect: onSelectProp, // Rename to avoid conflict if needed, though unused in original body aside from shadowing
    onPesquisar,
    leadsKanban,
    colunas,
    ordemColunas,
    periodo,
    pipelineId,
    qualificacao,
    responsaveis,
    user,
    cliente,
    ...other
}) {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    // A prop `user` nunca era passada pelo único call site (ChatSidebar), então
    // o item "Grupo" jamais aparecia. O contexto de auth é a fonte confiável;
    // a prop continua valendo como override se alguém precisar.
    const { user: authUser } = useAuth();
    const usuario = user || authUser;

    async function handleSelect(value) {
        if (value === 'negocio') {
            dispatch(setNegocio({ loading: false, openModal: true }));
        } else if (value === 'empresa') {
            dispatch(setEmpresa({ loading: false, openModal: true }));
        } else if (value === 'conversa') {
            dispatch(setConversa({ loading: false, openModal: true }));
        } else if (value === 'contato') {
            dispatch(setContato({ loading: false, openModal: true }));
        } else if (value === 'grupo') {
            dispatch(setGrupoWhatsapp({ loading: false, openModal: true }));
        }
        setOpen(false);
    }

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger asChild>
                <Button
                    className={`h-8 text-sm rounded-lg flex items-center ${BOTAO_RELEVO_PRIMARIO}`}
                    onClick={() => setOpen(true)}
                >
                    Criar
                    <Iconify className="text-white ml-1 mt-0.5" icon="mdi:add-bold" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                className="w-[200px] p-1"
                {...other}
            >
                <DropdownMenuItem onClick={() => handleSelect('conversa')} className="cursor-pointer">
                    <div className="flex flex-row items-center gap-2 mb-0.5">
                        <Iconify width={16} height={16} icon={'ri:whatsapp-fill'} />
                        <span className="text-[13px] font-semibold">Conversa</span>
                    </div>
                </DropdownMenuItem>

                <DropdownMenuItem onClick={() => handleSelect('negocio')} className="cursor-pointer">
                    <div className="flex flex-row items-center gap-2 mb-0.5">
                        <Iconify width={16} height={16} icon={'streamline:subscription-cashflow'} />
                        <span className="text-[13px] font-semibold">Negócio</span>
                    </div>
                </DropdownMenuItem>

                <DropdownMenuItem onClick={() => handleSelect('contato')} className="cursor-pointer">
                    <div className="flex flex-row items-center gap-2 mb-0.5">
                        <Iconify width={18} height={18} icon={'material-symbols:person-outline'} />
                        <span className="text-[13px] font-semibold">Contato</span>
                    </div>
                </DropdownMenuItem>

                {verifyRules(usuario?.rules, 'criar_grupo_whatsapp') && (
                    <DropdownMenuItem onClick={() => handleSelect('grupo')} className="cursor-pointer">
                        <div className="flex flex-row items-center gap-2 mb-0.5">
                            <Iconify width={16} height={16} icon={'solar:users-group-rounded-bold'} />
                            <span className="text-[13px] font-semibold">Grupo</span>
                        </div>
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}




